import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const IdPaisFormGroup = ({ values, setValues, handleChange, iError, iTouched, fIsSubmitting }) => {
  const __zariContext = React.useContext(ZariContext)
  const [listaPaises, setListaPaises] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelectInve(TiposTablaComunConstant.PAIS)
      .then(({ data }) => setListaPaises(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='PAIS' htmlFor='select-idPais' md={2} />
      <Col md={10}>
        <Field name='_idPais'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idPais'
              onChange={e => {
                handleChange(e)
                values._idPais = e.target.value
                values._idDepartamento = ''
                values._idProvincia = ''
                values._idDistrito = ''
                setValues(values)
              }}
            >
              <option value=''>Seleccionar</option>
              {listaPaises.map((val, key) => (
                <option key={key} value={val.codigo}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdPaisFormGroup)
